import { baseApi } from "./base.api";

export const categoriesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchCategories: build.query({
      query: (params) => ({ url: "/categories/fetch", method: "GET", params }),
      providesTags: ["Category"],
    }),
    fetchCategoriesAll: build.query({
      query: () => ({ url: "/categories/fetch/all", method: "GET" }),
      providesTags: ["Category"],
    }),
    fetchTrashedCategories: build.query({
      query: (params) => ({ url: "/categories/fetch/trashed", method: "GET", params }),
      providesTags: ["Category"],
    }),
    fetchCategoryById: build.query({
      query: (id) => ({ url: `/categories/fetch/${id}`, method: "GET" }),
      providesTags: ["Category"],
    }),
    createCategory: build.mutation({
      query: (body) => ({ url: "/categories/create", method: "POST", body }),
      invalidatesTags: ["Category"],
    }),
    updateCategory: build.mutation({
      query: ({ id, body }) => ({ url: `/categories/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Category"],
    }),
    changeCategoryStatus: build.mutation({
      query: (id) => ({ url: `/categories/status/${id}`, method: "PUT" }),
      invalidatesTags: ["Category"],
    }),
    restoreCategory: build.mutation({
      query: (id) => ({ url: `/categories/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Category"],
    }),
    bulkRestoreCategories: build.mutation({
      query: (body) => ({ url: "/categories/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Category"],
    }),
    deleteCategory: build.mutation({
      query: (id) => ({ url: `/categories/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Category"],
    }),
    bulkDeleteCategories: build.mutation({
      query: (body) => ({ url: "/categories/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Category"],
    }),
    destroyCategory: build.mutation({
      query: (id) => ({ url: `/categories/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Category"],
    }),
    bulkDestroyCategories: build.mutation({
      query: (body) => ({ url: "/categories/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Category"],
    }),
  }),
});

export const {
  useFetchCategoriesQuery,
  useFetchCategoriesAllQuery,
  useFetchTrashedCategoriesQuery,
  useFetchCategoryByIdQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useChangeCategoryStatusMutation,
  useRestoreCategoryMutation,
  useBulkRestoreCategoriesMutation,
  useDeleteCategoryMutation,
  useBulkDeleteCategoriesMutation,
  useDestroyCategoryMutation,
  useBulkDestroyCategoriesMutation,
} = categoriesApi;
